import { ConfigProvider } from 'antd';
import { antdTheme } from './theme/antdTheme';
// import Header from "./components/Header/Header";
// import PortfolioPage from "./pages/PortfolioPage/PortfolioPage";
import HomePage from "./pages/HomePage/HomePage";
import VerifyPage from "./pages/VerifyPage/VerifyPage";
import ResetPasswordPage from "./pages/ResetPasswordPage/ResetPassword";
import HowToDeleteAccountPage from "./pages/HowToDeleteAccount/HowToDeleteAccountPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage/TermsOfServicePage";
// import AboutPage from "./pages/AboutPage/AboutPage";
// import ContactPage from "./pages/ContactPage/ContactPage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <Router>
        {/* <Header /> */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/how-to-delete-account" element={<HowToDeleteAccountPage />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
